import { ListOutput } from '@allocab/allocab-standard-shared-types';
import { captureException } from '@sentry/react';

import { storage } from '../services/storage/storage';
import { t } from '../services/translations/translation';

export const getRandomNumber = (min: number, max: number) => {
  return Math.floor(Math.random() * (max - min + 1) + min);
};

export const generateRandomUUID = () => {
  const positions = Array.from({ length: 16 }).map(_ => 'a');
  positions[0] = 'l';
  positions[1] = 'u';
  positions[2] = 'n';

  // Shuffle array
  for (let i = positions.length - 1; i > 0; i--) {
    const j = getRandomNumber(0, i);
    [positions[i], positions[j]] = [positions[j], positions[i]];
  }

  const lowercaseCharSet = 'abcdefghijklmnopqrstuvwxyz';
  const uppercaseCharSet = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
  const numberCharSet = '0123456789';
  const allCharSet = `${lowercaseCharSet}${uppercaseCharSet}${numberCharSet}`;

  return positions
    .map(type => {
      let charSet = allCharSet;

      if (type === 'l') {
        charSet = lowercaseCharSet;
      } else if (type === 'u') {
        charSet = uppercaseCharSet;
      } else if (type === 'n') {
        charSet = numberCharSet;
      }

      return charSet.charAt(getRandomNumber(0, charSet.length));
    })
    .join('');
};

export const noop = (_a?: unknown) => {
  // Do nothing
};

export const assertNever = (value: never, errorMessage: string) => {
  captureException(new Error(errorMessage), {
    extra: { value },
  });
};

export const isMobile = () => {
  let check = false;
  (function (a) {
    if (
      /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(
        a,
      ) ||
      // eslint-disable-next-line no-useless-escape
      /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
        a.substr(0, 4),
      )
    )
      check = true;
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    //@ts-ignore
  })(navigator.userAgent || navigator.vendor || window.opera);
  return check;
};

export const hoursOptions = [
  '00',
  '01',
  '02',
  '03',
  '04',
  '05',
  '06',
  '07',
  '08',
  '09',
  '10',
  '11',
  '12',
  '13',
  '14',
  '15',
  '16',
  '17',
  '18',
  '19',
  '20',
  '21',
  '22',
  '23',
];

export const minutesOptions = ['00', '05', '10', '15', '20', '25', '30', '35', '40', '45', '50', '55'];

export const getFullName = (firstName?: string, lastName?: string) => {
  if (!firstName && !lastName) return t('pwa.common.unknown');
  if (!firstName) return lastName as string;
  if (!lastName) return firstName;
  return `${firstName} ${lastName}`;
};

export const redirectToAuth = (authBaseName: string, path = '', redirectPath?: string) => {
  const redirectTo = encodeURIComponent(redirectPath || `${window.location.pathname}${window.location.search}`);
  storage.setJSONItem('authRedirect', { createAt: Date.now(), path: redirectTo }, true);
  window.location.href = `${authBaseName}${path}`;
};

export const redirectToLogin = (authBaseName: string, redirectPath?: string) => {
  redirectToAuth(authBaseName, 'login', redirectPath);
};

export const redirectToSignup = (authBaseName: string, redirectPath?: string) => {
  redirectToAuth(authBaseName, 'sign-up', redirectPath);
};

export type ReferenceLocation = {
  lat?: number;
  lng?: number;
  placeId?: string;
};

export const getReferenceLocation = (steps: ReferenceLocation[] | null | undefined) => {
  if (steps && steps.length > 0) {
    const validStep = steps.find(step => (!!step.lat && !!step.lng) || !!step.placeId);
    if (validStep) {
      return { lat: validStep.lat, lng: validStep.lng, placeId: validStep.placeId };
    }
  }

  return undefined;
};

export const getIsIOS = () => {
  if (typeof navigator === 'undefined') return false; // sécurité SSR

  const ua = navigator.userAgent || navigator.vendor;

  return /iPad|iPhone|iPod/.test(ua) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
};

export const itemsToListOutput = <T>(items: T[]): ListOutput<T> => ({
  items,
  nbItems: items.length,
  totalItems: items.length,
});
